import { render, staticRenderFns } from "./VaBenefits.vue?vue&type=template&id=3e256f9c&lang=pug"
import script from "./VaBenefits.vue?vue&type=script&lang=js"
export * from "./VaBenefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports